import { useEffect, useRef, useState } from 'react';
import { Descriptions, Tooltip } from 'antd';
import dayjs from 'dayjs';
import {
  getBizOpTypeEnum,
} from "@/services/customerServices.ts";
import ChooseTagModal from '@/components/ChooseTagModal';
import styles from './index.module.less';

export default function BasicInfo ({ editTag = false, basicInfo = {}, reload = () => ({}) })  {
  const [openChooseTagModal, setOpenChooseTagModal] = useState(false);
  const [tagList, setTagList] = useState<Array<any>>([]);

  useEffect(() => {
    fetchBizOpTypeEnum();
  }, []);

  const handleChooseTagModal = () => {
    setOpenChooseTagModal(true);
  }

  const fetchBizOpTypeEnum = async () => {
    try {
      const res: any = await getBizOpTypeEnum();
      const data = {
        key: 1,
        title: '需求标签',
        tags: [...res]
      }
      if (res) {
        setTagList([data]);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const items = [
    {
      key: '11',
      label: '所属门店',
      children: (
        <Tooltip title={ (basicInfo as any )?.orgName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.orgName }</div>
        </Tooltip>
      ),
    },
    {
      key: '0',
      label: '楼盘名称',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.buildingName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.buildingName }</div>
        </Tooltip>
      ),
    },
    {
      key: '1',
      label: '客户来源',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.channelName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.channelName }</div>
        </Tooltip>
      ),
    },
    {
      key: '2',
      label: '门牌号',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.doorNo }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.doorNo }</div>
        </Tooltip>
      ),
    },
    {
      key: '3',
      label: '房屋属性',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.houseNatureName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.houseNatureName }</div>
        </Tooltip>
      ),
    },
    {
      key: '4',
      label: '房屋状态',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.houseStatusName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.houseStatusName }</div>
        </Tooltip>
      ),
    },
    {
      key: '5',
      label: '房屋类型',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.houseKindName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.houseKindName }</div>
        </Tooltip>
      ),
    },
    {
      key: '6',
      label: '户型',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.layoutName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.layoutName }</div>
        </Tooltip>
      ),
    },
    {
      key: '7',
      label: '建筑面积',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.constructArea }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.constructArea }</div>
        </Tooltip>
      ),
    },
    {
      key: '8',
      label: '套内面积',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.innerArea }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.innerArea }</div>
        </Tooltip>
      ),
    },
    {
      key: '9',
      label: '层高',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.houseHight }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.houseHight }</div>
        </Tooltip>
      ),
    },
    {
      key: '10',
      label: '交房时间',
      children: (
        <Tooltip title={ (basicInfo as any )?.houseInfo?.handoverDate }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.houseInfo?.handoverDate ? dayjs((basicInfo as any )?.houseInfo?.handoverDate).format('YYYY-MM-DD') : '' }</div>
        </Tooltip>
      ),
    },
  ];

  const items2 = [
    {
      key: '0',
      label: '客户需求标签',
      children: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(112, 163, 16, 1)', fontWeight: 400, fontSize: '12px', lineHeight: '22px', color: 'rgba(255, 255, 255, 1)', padding: '0 5px', marginRight: '5px', borderRadius: '3px' }}>
              { (basicInfo as any )?.dtlInfo?.bizTypeName }
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '1',
      label: '居住目的',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.livePurposeName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.livePurposeName }</div>
        </Tooltip>
      ),
    },
    {
      key: '13',
      label: '装修预算',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.budgetName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.budgetName }</div>
        </Tooltip>
      ),
    },
    {
      key: '14',
      label: '装修风格',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.designStyleName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.designStyleName }</div>
        </Tooltip>
      ),
    },
    {
      key: '2',
      label: '常住人口',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.permanentResidentsName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.permanentResidentsName }</div>
        </Tooltip>
      ),
    },
    {
      key: '3',
      label: '签单意向',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.signIntentionName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.signIntentionName }</div>
        </Tooltip>
      ),
    },
    {
      key: '4',
      label: '产品意向',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.intentionProductName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.intentionProductName }</div>
        </Tooltip>
      ),
    },
    {
      key: '5',
      label: '预计装修日期',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.expectRenovationDate }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.expectRenovationDate ? dayjs((basicInfo as any )?.dtlInfo?.expectRenovationDate).format('YYYY-MM-DD') : '' }</div>
        </Tooltip>
      ),
    },
    {
      key: '6',
      label: '预计定装修日期',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.estimatedRenovationTime }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.estimatedRenovationTime ? dayjs((basicInfo as any )?.dtlInfo?.estimatedRenovationTime).format('YYYY-MM-DD') : '' }</div>
        </Tooltip>
      ),
    },
    {
      key: '7',
      label: '期待入住时间',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.lookingForwardToStayingTime }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.lookingForwardToStayingTime ? dayjs((basicInfo as any )?.dtlInfo?.lookingForwardToStayingTime).format('YYYY-MM-DD') : '' }</div>
        </Tooltip>
      ),
    },
    {
      key: '8',
      label: '痛点',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.painPoint }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.painPoint }</div>
        </Tooltip>
      ),
    },
    {
      key: '9',
      label: '痒点',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.itchPoint }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.itchPoint }</div>
        </Tooltip>
      ),
    },
    {
      key: '10',
      label: '爆破点',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.breakPoint }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.breakPoint }</div>
        </Tooltip>
      ),
    },
    {
      key: '11',
      label: '障碍点',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.blockPoint }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.blockPoint }</div>
        </Tooltip>
      ),
    },
    {
      key: '12',
      label: '备注',
      children: (
        <Tooltip title={ (basicInfo as any )?.dtlInfo?.remark }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.dtlInfo?.remark }</div>
        </Tooltip>
      ),
    },
  ];

  const items3 = [
    {
      key: '1',
      label: '线索ID',
      children: (
        <Tooltip title={ (basicInfo as any )?.clueInfo?.clueId }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.clueInfo?.clueId }</div>
        </Tooltip>
      ),
    },
    {
      key: '2',
      label: '报名城市',
      children: (
        <Tooltip title={ (basicInfo as any )?.clueInfo?.cityName }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.clueInfo?.cityName }</div>
        </Tooltip>
      ),
    },
    {
      key: '3',
      label: '报名页面',
      children: (
        <Tooltip title={ (basicInfo as any )?.clueInfo?.applyUrl }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.clueInfo?.applyUrl }</div>
        </Tooltip>
      ),
    },
    {
      key: '4',
      label: '报名页说明',
      children: (
        <Tooltip title={ (basicInfo as any )?.clueInfo?.applyPageDesc }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.clueInfo?.applyPageDesc }</div>
        </Tooltip>
      ),
    },
    {
      key: '5',
      label: '报名时间',
      children: (
        <Tooltip title={ (basicInfo as any )?.clueInfo?.signUpTime }>
          <div className={styles.ellipsis}>{ (basicInfo as any )?.clueInfo?.signUpTime ? dayjs((basicInfo as any )?.clueInfo?.signUpTime).format('YYYY-MM-DD') : ''}</div>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div className={styles.basicInfoBox}>
        <Descriptions style={{ marginTop: '15px' }} title="楼盘信息" items={items} />
        <Descriptions style={{ marginTop: '15px' }} title="家空间需求" items={items2} />
        <Descriptions style={{ marginTop: '15px', marginBottom: '15px' }} title="来源信息" items={items3} />
      </div>
      { openChooseTagModal && <ChooseTagModal isBizTag={true} reload={reload} editId={(basicInfo as any)?.id} list={(tagList as any)} single={true} open={openChooseTagModal} onClose={() => setOpenChooseTagModal(false)} /> }
    </>
  )
}